// extracted by mini-css-extract-plugin
export default {"thLabel":"ArticlesTable_thLabel__Ek2aM"};